import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Modal, Form } from 'react-bootstrap';
import { IoCloudUploadOutline } from "react-icons/io5";

import axios from '../../axios';
import apiError from '../../error';
import Loader from '../loader/loader'
import sampleFile from '../../assets/sample_csv_file.csv';
import './rightside-modal.css'
export default class UploadCSVModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            groupId: this.props.groupId,
            parentId: this.props.parentId,
            remainingUsersLimit: 0,
            csvErrors: []
        }
        this.inputFile = React.createRef();
    }
    fetchLicenseDetails = async () => {
        try {
            let licenseDetails = await axios.get('/api/overview/licence');
            this.setState({ remainingUsersLimit: licenseDetails.data.userlimit - licenseDetails.data.targetCount });
        } catch (error) {
            apiError(error);
        }
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.groupId !== prevProps.groupId) {
            this.setState({ groupId: this.props.groupId })
        }
        if (this.props.show !== prevProps.show) {
            this.fetchLicenseDetails();
        }
    }

    createGroup = (e) => {
        if (!this.props.groupName && this.props.groupName.length === 0) {
            toast.error("Please Enter Group Name First");
            return false;
        }
        this.setState({ loading: true });
        axios.post('/api/groups', {
            name: this.props.groupName,
            parentId: this.props.parentId,
        }, {})
            .then(res => {
                this.props.handleGroupId(res.data.groupId);
                this.setState({ groupId: res.data.groupId, loading: false });
                this.uploadFile(e);
            })
            .catch(err => {
                this.setState({ loading: false });
                apiError(err);
            })
    }

    handleGroupFileUpload = (e) => {
        if (e && e.target && e.target.files) {
            e.persist();
            this.validateFileFormat(e);
        }
    }

    validateFileFormat = (e) => {
        const fileToRead = e.target.files[0];
        const reader = new FileReader();
        reader.readAsText(fileToRead);

        reader.onload = (event) => {
            const csv = event.target.result;
            const allTextLines = csv.split(/\r\n|\n/).filter(line => line.trim() !== '');

            if (allTextLines.length <= 1) {
                toast.error('❌ Empty CSV File is not allowed. Please upload a valid file with header and at least one row.');
                return;
            }

            const headers = allTextLines[0].split(',').map(h => h.trim().toLowerCase());
            const requiredHeaders = ["firstname", "lastname", "email", "phone", "position", "countrycode", "department", "location", "manageremail"];

            const arraysHaveSameElements = (arr1, arr2) => {
                const sorted1 = [...arr1].sort();
                const sorted2 = [...arr2].sort();
                return sorted1.length === sorted2.length && sorted1.every((val, i) => val === sorted2[i]);
            };

            if (!arraysHaveSameElements(headers, requiredHeaders)) {
                toast.error('❌ Invalid CSV header format. Please make sure your file matches the required format.');
                console.error('Expected Headers:', requiredHeaders);
                console.error('Received Headers:', headers);
                return;
            }

            const invalidRows = [];
            for (let i = 1; i < allTextLines.length; i++) {
                const row = allTextLines[i].split(',').map(cell => cell.trim());
                if (row.length !== headers.length) {
                    invalidRows.push({ line: i + 1, error: '❌ Incorrect number of columns' });
                    continue;
                }

                const rowData = Object.fromEntries(headers.map((key, idx) => [key, row[idx]]));
                const errors = [];

                // Validate required fields
                if (!rowData.firstname) {
                    errors.push('Missing "firstname"');
                }

                if (!rowData.email) {
                    errors.push('Missing "email"');
                } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(rowData.email)) {
                    errors.push('Invalid email format');
                }

                // Validate optional fields if present
                if (rowData.phone && !/^\+?\d{10,15}$/.test(rowData.phone)) {
                    errors.push('Invalid phone number format');
                }

                if (rowData.manageremail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(rowData.manageremail)) {
                    errors.push('Invalid manager email format');
                }

                // Example: you can validate other fields similarly
                // if (!rowData.position) errors.push('Missing "position"'); ← only if required

                if (errors.length > 0) {
                    invalidRows.push({
                        line: i + 1,
                        row: rowData,
                        error: errors.join('; ')
                    });
                }
            }

            if (invalidRows.length > 0) {
                this.setState({ csvErrors: invalidRows })
            } else {
                this.uploadFile(e); // Proceed to upload
            }
        };

        reader.onerror = () => {
            toast.error('❌ Failed to read the file. Please try again with a valid CSV.');
        };
    };

    uploadFile = (e) => {
        if (this.state.groupId && parseInt(this.state.groupId, 10)) {
            e.persist();
            var formData = new FormData();
            formData.append('file', e.target.files[0]);
            axios.post('/api/groups/file/' + this.state.groupId, formData, {
                headers: {
                    "Content-type": "multipart/form-data",
                }
            })
                .then(res => {
                    this.props.CSVHandle();
                    // if(this.state.groupId!=-1) this.props.nextPath('/department/groups');
                    toast.success("CSV File Uploaded Successfully And Data Will Reflect In Sometimes");
                    if (this.state.groupId > 0) {
                        this.props.handleGroupModalClose();
                    }
                })
                .catch(err => {
                    apiError(err);
                })
        } else {
            this.createGroup(e);
            return false;
        }
    }

    onButtonClick = () => {
        this.inputFile.current.click();
    };

    render() {
        let { csvErrors = [] } = this.state;
        return (
            <Modal className="info-filter right mainfooterModal creatGroupModal" show={this.props.show} onHide={this.props.CSVHandle} autoFocus keyboard>
                <Modal.Header closeButton>
                    <div>
                        <h5>Bulk Import Members</h5>
                        <p>Upload a CSV file to add members in bulk.</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-md-12">
                        <div className="noteSection">
                            <p><b>Note:</b> Your remaining user limit is {this.state.remainingUsersLimit}. Ensure your CSV file has no more than {this.state.remainingUsersLimit} unique users; otherwise, only the first {this.state.remainingUsersLimit} unique users will be uploaded.</p>
                        </div>
                        <div className="uploadBlock">
                            <IoCloudUploadOutline className="upload-icon"></IoCloudUploadOutline>
                            <h6>Select a CSV file to upload</h6>

                            <div className="emailAttachment">
                                <Form.Group>
                                    <Form.File id="exampleFormControlFile1" accept=".csv" ref={this.inputFile} onChange={this.handleGroupFileUpload} />
                                </Form.Group>
                            </div>
                            <hr style={{ 'width': '20%', 'margin': '5px auto', 'border-top': '3px solid rgba(0, 0, 0, 0.1)' }}></hr>
                            <div>
                                <a variant="link" className="blue-text" href={sampleFile}>Click here to download sample CSV file</a>
                            </div>
                        </div>
                    </div>
                    {csvErrors.length > 0 && (
                        <div className="mt-4 overflow-x-auto border border-red-400 rounded-lg p-4 bg-red-50">
                            <h6 className="text-red-600 font-semibold mb-2">CSV Validation Errors</h6>
                            <table className="table-auto w-full text-left border-collapse text-sm">
                            <thead>
                                <tr className="bg-red-100">
                                <th className="px-4 py-2 border">Line</th>
                                <th className="px-4 py-2 border">Row</th>
                                <th className="px-4 py-2 border">Error</th>
                                </tr>
                            </thead>
                            <tbody>
                                {csvErrors.map((err, index) => (
                                <tr key={index}>
                                    <td className="px-4 py-2 border">{err.line}</td>
                                    <td className="px-4 py-2 border text-xs">
                                    <pre className="whitespace-pre-wrap break-words">
                                        {JSON.stringify(err.row, null, 2)}
                                    </pre>
                                    </td>
                                    <td className="px-4 py-2 border text-red-700">{err.error}</td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>
                    )}
                </Modal.Body>
                <div className="modalFooter">
                    <div className="row">
                        <div className="col-md-12 text-right">
                            <button type="button" className="btn closeBtn" onClick={this.props.CSVHandle}>Cancel</button>
                        </div>
                    </div>
                </div>
                {this.state.loading ? <Loader></Loader> : null}
            </Modal>
        );
    }
}